import { useState } from "react";
import { PageHero, Container, CTASection } from "@/components/common/Section";
import { Reveal } from "@/lib/anim";
import { CASE_STUDIES } from "@/lib/content";

const FILTERS = ["All", ...new Set(CASE_STUDIES.map((c) => c.category))];

export default function Work() {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? CASE_STUDIES : CASE_STUDIES.filter((c) => c.category === filter);

  return (
    <>
      <PageHero
        eyebrow="Selected Work"
        title="Technology in production."
        copy="A selection of payment and financial infrastructure engagements: platforms, gateways and integrations running in real production environments."
        testid="work-page-title"
      >
        <Reveal delay={140} className="mt-9 flex flex-wrap gap-2.5">
          {FILTERS.map((f) => (
            <button
              key={f}
              type="button"
              data-testid={`work-filter-${f.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => setFilter(f)}
              aria-pressed={filter === f}
              className={`rounded-[10px] border px-4 py-2 text-[13px] font-semibold transition-all duration-200 ${
                filter === f
                  ? "border-[#1D305B] bg-[#1D305B] text-white"
                  : "border-[#E2E8F0] bg-white text-[#475569] hover:border-[#1D305B]/40"
              }`}
            >
              {f}
            </button>
          ))}
        </Reveal>
      </PageHero>

      <section className="py-20 lg:py-24">
        <Container>
          <div className="grid gap-5 md:grid-cols-2">
            {items.map((c, i) => (
              <Reveal
                key={c.name}
                delay={(i % 2) * 80}
                data-testid={`work-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex flex-col rounded-2xl border border-[#E2E8F0] bg-white p-8 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_48px_-20px_rgba(15,23,42,0.18)]"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="btn-brand flex h-11 w-11 items-center justify-center rounded-[10px] text-base font-bold text-white">
                    {c.name[0]}
                  </span>
                  <span className="text-right text-[11px] font-semibold uppercase tracking-[0.14em] text-[#0EA5A4]">
                    {c.category}
                  </span>
                </div>
                <h2 className="mt-6 text-2xl font-semibold text-[#1D305B]">{c.name}</h2>
                <p className="mt-3 text-[15px] leading-relaxed text-[#64748B]">{c.desc}</p>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 text-sm text-[#94A3B8]">
            Representative engagements. Detailed architecture walkthroughs are available on request.
          </p>
        </Container>
      </section>

      <CTASection
        title="Want results like these in production?"
        copy="Tell us about the platform, gateway or integration you're planning."
      />
    </>
  );
}
